import "../styles/music.css";

const Music = () => {
  return (
    <>
      <h2>Music</h2>
      <hr />

      <div className="releases">

        <div className="albumItem">
          <div>
            <a href="https://www.instagram.com/p/DMi2L3Xseqc/?img_index=1" target="_blank">
              <img
                className="album"
                src="images/laikatonal.jpg"
                alt="Laikatonal #1 CD"
              />
            </a>
            <h4>Laikatonal #1</h4>
          </div>
        </div>

        <div className="albumItem">
          <div>
            <a href="https://xkatedral.bandcamp.com/track/inertia" target="_blank">
              <img
                className="album"
                src="https://f4.bcbits.com/img/a0671490817_16.jpg"
                alt="XKatedral - Anthology Series II Cover"
              />
              <h4>XKatedral - Anthology Series II</h4>
            </a>
          </div>
        </div>

        <div className="albumItem">
          <div>
            <a href="https://mollerrecords.bandcamp.com/track/wilma-hulten-and-elif-yalva-orchestra-of-light" target="_blank">
              <img
                className="album"
                src="https://f4.bcbits.com/img/a3629223309_10.jpg"
                alt="My Heart of Noise Album Cover"
              />
              <h4>Elif Yalvaç - My Heart of Noise</h4>
            </a>
          </div>
        </div>

        <div className="albumItem">
          <div>
            <a href="https://www.svenskmusik.org/sv/s%C3%B6k?person=23411" target="_blank">
              <img id="score" src="images/scores.png" alt="sheet music" />
              <h4>Scores</h4>
            </a>
          </div>
        </div>
      </div>
      <hr />

      <div className="projects">

        <a href="https://www.livinginsound.fi/oct26_audioworks.html" target="_blank">
          <i>Elsewhere</i> on symposium "How to live together in sound?" October 12 &ndash; 14 2026
        </a>

        <br />
        <br />

        <a href="https://radiokapital.pl/shows/carewaves/15-collision-points-2026/" target="_blank">
          <i>Mina kammare</i> on carewaves #15 – Radio Kapital (at 32:00)
        </a>

        <br />
        <br />
        
        <a href="https://onaironsite.com/artists/wilma-hulten" target="_blank">
          <i>Elsewhere</i> on On Air - On Site 2026
        </a>

        <br />
        <br />

        <a href="https://paletten.net/tidskrift/paletten-nr-342" target="_blank">
          Graphic scores published in Paletten no. 342, text by Amina Hocine
        </a>

        <br />
        <br />

        <a href="https://radiophrenia.scot/calendar/mon-04/" target="_blank">
          <i>Elsewhere</i> on Radiophrenia 2025
        </a>

        <br />
        <br />

        <a href="https://ungnordiskmusik.is/artist/wilma_hulten/" target="_blank">
          String quartet <i>Everred</i> performed at UNM 2022
        </a>

        <br />
        <br />

        <a href="https://soundcloud.com/lillaakademienkomposition/hettan-wilma-hulten?si=7a70e2dae7004538aa3d08843ad47c4c&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing" target="_blank">
          <i>Hettan</i> for Stockholm Saxophone Quartet
        </a>

        <br />
        <br />

        <a href="https://www.youtube.com/watch?v=r90GS1Go1gc" target="blank" >
          Recorded live electronics set – Fylkingen
        </a>

        <br />
        <br />

        <a href="https://cashmereradio.com/chronopolis/inert-mass/" target="_blank">
          Algorithmic piece <i>Inert Mass</i> for Chronopolis / Cashmere Radio
        </a>

        <br />
        <br />

      </div>
    </>
  );
};

export default Music;
